<script lang="ts">
	import Notifications from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/CommonDeviceTabs/Notifications.svelte';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
</script>

<Notifications {device} />
